import { Trip } from '../../lib/types/models/trip/trip'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTrip(id: number) {
  return restApiClient.url(constructApiUrl(API.trips.get.url, { id })).get<Trip>()
}
